import React from 'react';
import { StyleSheet, TouchableOpacity, TouchableOpacityProps, View } from 'react-native';

import RightIcon from '@/assets/icons/chevronRight';
import { SEPARATOR_HEIGHT, common } from '@/styles/styles';

import { Text } from './TextComponent';
import { ds } from './lib/design.system';

export const ButtonMore = ({ label, children, style, ...props }: TouchableOpacityProps & { label?: string }) => {
    return (
        <TouchableOpacity activeOpacity={0.8} style={[styles.buttonMore, common.spaceBetweenRow, style]} {...props}>
            <Text variant="bodyMedium" color={ds.colorToken.text.primary}>
                {label}
            </Text>
            <View style={[common.row, common.alignCenter]}>
                {children}
                <View style={styles.rightIcon}>
                    <RightIcon />
                </View>
            </View>
        </TouchableOpacity>
    );
};

const styles = StyleSheet.create({
    buttonMore: {
        minHeight: 56,
        borderBottomWidth: SEPARATOR_HEIGHT,
        borderBottomColor: ds.colorValue.border.strong,
    },
    rightIcon: {
        marginLeft: 22,
    },
});
